/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Fulfillment_Sync_Not_RetryableInputs */

const en_error_fulfillment_sync_not_retryable = /** @type {(inputs: Error_Fulfillment_Sync_Not_RetryableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The shipment cannot be sent to the warehouse again now: its last instruction is still on its way.`)
};

/**
* | output |
* | --- |
* | "The shipment cannot be sent to the warehouse again now: its last instruction is still on its way." |
*
* @param {Error_Fulfillment_Sync_Not_RetryableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_fulfillment_sync_not_retryable = /** @type {((inputs?: Error_Fulfillment_Sync_Not_RetryableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Fulfillment_Sync_Not_RetryableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_fulfillment_sync_not_retryable(inputs)
});